module.exports = __webpack_public_path__ + "c_static/img/home_certificating.630ad1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/home_certificating.png
// module id = XwCj
// module chunks = 33